// import { combineReducers } from 'redux';
// import { navRootSaga } from './sagas';
// import { navReducer } from './reducers';
import { createSlice } from '@reduxjs/toolkit';

// const sagas = [navRootSaga];

// const rootReducer = combineReducers({
//     nav: navReducer
// });

/**
 * @type {EventsListingState}
 */
const initialState = {
    date: '',
    filters: {
        eventTypes: [],
        teams: [],
        eventLocations: []
    }
};

const eventsListing = createSlice({
    name: 'eventsListing',
    initialState: () => initialState,
    reducers: {
        setNavItem: (state, action) => {
            const { navItem, value } = action.payload;

            if (state[navItem] === null) {
                state[navItem] = value;
            } else if (Array.isArray(state[navItem])) {
                state[navItem] = value;
            } else if (typeof state[navItem] === 'object') {
                state[navItem] = { ...state[navItem], ...value };
            } else {
                state[navItem] = value;
            }
        },
        setFilterItem: (state, action) => {
            const { filterItem, value } = action.payload;
            state.filters[filterItem] = value;
        }
    }
});

// RTK Query update: Export the slice reducer and actions
if (PULSE.app.redux) {
    PULSE.app.redux.reducers.eventsListing = {
        root: eventsListing.reducer
    };
    PULSE.app.redux.actions = {
        ...PULSE.app.redux.actions,
        eventsListing: eventsListing.actions
    };
} else {
    PULSE.app.redux = {
        actions: {
            eventsListing: eventsListing.actions
        },
        reducers: {
            root: {
                eventsListing: eventsListing.reducer
            }
        }
    };
}

export const { setNavItem, setFilterItem } = eventsListing.actions;
